export const MENU_WIDTH = 280;
export const MENU_WIDTH_COLLAPSED = 50;
export const CONTENT_MARGIN = 290;
export const CONTENT_MARGIN_COLLAPSED = 60;
